import { put, takeLatest, call } from 'redux-saga/effects';
import types from 'redux/types';
import { notifyError } from 'helpers/handleNotification';
import userServices from 'services/userServices';

function* getUser(data) {
  try {
    const response = yield call(userServices.getUserServlet);
    userServices.setUserInfoToStorage(response?.data);
    userServices.updateCachedUser(response?.data);
    yield put({ type: types.REQUEST_USER_SUCCESS, data: response?.data || {} });
  } catch (error) {
    yield put({ type: types.REQUEST_USER_FAILED, error });
    notifyError((error || '').toString());
  }
}

export default function* watchGetAPIFunction() {
  yield takeLatest(types.REQUEST_USER, getUser);
}
